import React from 'react';
import { SparklesIcon } from 'lucide-react';

/**
 * Talab's slot beside its messages. Uses the same mark as every other
 * Talab message today; when the Talab avatar exists, replace the contents
 * here and every live-search state picks it up.
 */
export function AssistantMark() {
  return <div aria-hidden="true" className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-primary-indigo to-ai-purple flex items-center justify-center shadow-md" data-id="element-3376" data-mp="jei2le2r7zsd">
      <SparklesIcon className="w-5 h-5 text-white" data-id="element-3377" data-mp="sfzcufthd795" />
    </div>;
}